export default "__VITE_ASSET__1wAG9Xcy__"